<template>
  <v-container fluid class="ma-4 mt-3 px-8">
    <v-row>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.year_batch"
          :items="batches"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Batch"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.usn_id"
          outlined
          dense
          clearable
          hide-details="auto"
          label="USN"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="form.application_id"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Application ID"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-autocomplete
          v-model="form.program_id"
          :items="programs"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Programme"
          :item-text="
            (item) =>
              `${item.degree.short_name} ${
                item.specialization ? `- ${item.specialization}` : ''
              }`
          "
          item-value="id"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-autocomplete
          v-model="form.partner_id"
          :items="partners"
          item-text="name"
          item-value="id"
          outlined
          dense
          clearable
          hide-details="auto"
          label="Partner"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-autocomplete
          v-model="form.type"
          :items="types"
          outlined
          dense
          hide-details="auto"
          label="File Type*"
          clearable
          item-text="text"
          item-value="id"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4" class="py-0 my-0 d-flex align-center">
        <v-btn
          class="mr-2"
          color="primary"
          @click="previewReceipt"
          :loading="loading"
          :disabled="!form.type"
        >
          Preview & Search
        </v-btn>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-2"
              color="primary"
              @click="getExports"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Refresh List</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-alert v-if="text" type="info" outlined dense class="my-6">
      {{ text }}
    </v-alert>

    <v-dialog v-model="previewDialog" max-width="500" persistent>
      <v-card class="secondary" height="100%">
        <v-card-title class="font-weight-medium secondary--text primary">
          Confirm Export

          <v-spacer></v-spacer>
          <v-btn small icon @click="previewDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="previewStats.student_count > 0">
            <p class="text-subtitle-1">
              <strong>Students Found:</strong> {{ previewStats.student_count }}
            </p>
            <p class="text-subtitle-1">
              <strong>Receipts to Generate:</strong>
              {{ previewStats.receipt_count }}
            </p>
            <p class="caption grey--text">
              The process will run in the background. You can download the file
              from the list below once completed.
            </p>
          </div>
          <div v-else class="text-center py-4">
            <v-icon large color="warning">mdi-alert-circle-outline</v-icon>
            <p class="mt-2 red--text font-weight-bold">
              No students found matching these criteria.
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="pt-0 mx-2">
          <v-spacer></v-spacer>
          <v-btn
            class="primary"
            :disabled="previewStats.student_count === 0"
            @click="initiateExport"
            :loading="loading"
          >
            Start Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row align="start" class="px-0 mt-6">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <span class="text-h6">Export History</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :items="exportss"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.status`]="{ item }">
              <v-chip
                small
                :color="getStatusColor(item.status)"
                text-color="white"
              >
                {{ item.status }}
              </v-chip>
            </template>

            <template #[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    color="primary"
                    :loading="downloadingId === item.id"
                    @click="downloadIndividualReceipt(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{
                      item.status === "Completed"
                        ? "mdi-download"
                        : "mdi-clock-outline"
                    }}
                  </v-icon>
                </template>
                <span>{{
                  item.status === "Completed" ? "Download File" : "Check Status"
                }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="mr-2"
                    color="error"
                    @click="deleteOpenDialog(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-delete
                  </v-icon>
                </template>
                <span>Delete File</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteDialog" width="500" persistent>
      <confirmationDialog
        v-if="deleteDialog"
        confirmationText="Are you sure you want to delete this export record? The file will be lost."
        @closeDialog="deleteDialog = false"
        @saveDialog="deleteItem()"
      />
    </v-dialog>
  </v-container>
</template>
<script>
import { rules } from "@/helpers/rules";
import { exportHeaders } from "@/constants/headers";
import confirmationDialog from "@/components/confirmationDialog.vue";

export default {
  components: { confirmationDialog },
  data: () => ({
    rules,
    form: {
      partner_id: null,
      type: null,
      year_batch: null,
      program_id: null,
      usn_id: null,
    },
    loading: false,
    downloadingId: null,
    types: [
      { text: "PDF", id: "pdf" },
      { text: "ZIP", id: "zip" },
    ],
    batches: [],
    partners: [],
    programs: [],
    text: null,
    headers: exportHeaders,
    exportss: [],
    exportData: null,
    deleteDialog: false,
    previewDialog: false,
    previewStats: {
      student_count: 0,
      receipt_count: 0,
    },
  }),
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Bulk Receipt Download" }]);
    Promise.all([
      this.generateBatchList(),
      this.getPrograms(),
      this.getPartners(),
      this.getExports(),
    ]);
  },
  methods: {
    getStatusColor(status) {
      if (status === "Completed") return "success";
      if (status === "Failed") return "error";
      return "warning"; // Pending
    },
    async getExports() {
      try {
        const res = await this.$axios.get("exports");
        this.exportss = res.data.data.sort((a, b) => b.id - a.id);
      } catch (error) {
        console.error(error);
      }
    },
    async previewReceipt() {
      this.loading = true;
      this.text = null;
      try {
        const form = this.objectToFilteredObject(this.form);
        const response = await this.$axios.get(`/preview_export`, {
          params: { ...form },
        });

        this.previewStats = response.data.data;
        this.previewDialog = true;
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: error.response?.data?.error || "Preview failed",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    async initiateExport() {
      this.previewDialog = false;
      this.loading = true;
      this.text = "Starting background export...";
      try {
        const form = this.objectToFilteredObject(this.form);
        const response = await this.$axios.get(`/start_export`, {
          params: { ...form },
        });
        const newExport = response.data.data;
        this.text = `Export started! Reference: ${newExport.reference}. Please check the list below.`;
        this.getExports();
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: "Failed to start export",
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },
    async downloadIndividualReceipt(item) {
      this.downloadingId = item.id;
      try {
        const response = await this.$axios.get(
          `/download_export_receipt/${item.reference}`,
          { responseType: "blob" },
        );
        const isJson =
          response.headers["content-type"] &&
          response.headers["content-type"].includes("application/json");
        if (isJson || response.status === 202) {
          const textData = await response.data.text();
          const jsonData = JSON.parse(textData);
          if (response.status === 202) {
            this.$store.commit("showSnackbar", {
              message: jsonData.error || "Still processing... please wait.",
              color: "info",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: jsonData.error || "Download failed.",
              color: "error",
            });
          }
          this.getExports();
        } else {
          this.triggerBrowserDownload(response, item);
          this.$store.commit("showSnackbar", {
            message: "Download started",
            color: "success",
          });
        }
      } catch (error) {
        console.error(error);
        this.$store.commit("showSnackbar", {
          message: "An error occurred",
          color: "error",
        });
      } finally {
        this.downloadingId = null;
      }
    },
    triggerBrowserDownload(response, item) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const headerFilename = response.headers["content-disposition"]
        ? response.headers["content-disposition"]
            .split("filename=")[1]
            .replace(/"/g, "")
        : `receipts_${item.reference}.${item.type}`;

      link.download = headerFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    objectToFilteredObject(obj) {
      const newObj = { ...obj };
      if (newObj.year_batch) {
        const [year, batch] = newObj.year_batch.split("-");
        newObj.year = year;
        newObj.batch = batch;
        delete newObj.year_batch;
      }
      return Object.keys(newObj)
        .filter(
          (key) =>
            newObj[key] !== undefined &&
            newObj[key] !== null &&
            newObj[key] !== "",
        )
        .reduce((acc, key) => {
          acc[key] = newObj[key];
          return acc;
        }, {});
    },
    deleteOpenDialog(item) {
      this.exportData = { ...item };
      this.deleteDialog = true;
    },
    async deleteItem() {
      try {
        await this.$axios.delete(`exports/${this.exportData.id}`);
        this.$store.commit("showSnackbar", {
          message: "Deleted successfully",
          color: "success",
        });
        this.deleteDialog = false;
        this.getExports();
      } catch (error) {
        this.$store.commit("showSnackbar", {
          message: "Delete failed",
          color: "error",
        });
      }
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getPartners() {
      try {
        const response = await this.$axios.get("/partners");
        this.partners = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getPrograms() {
      try {
        const response = await this.$axios.get("/programs");
        this.programs = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
